/**
 * LeftSideSnapshotSelect.js
 * Created by zl952fc on 11/23/2020.
 */

import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import {documentSources} from '../../../util/uiconstants';
import EllipseControl from '../../Common/EllipsesControl/EllipsesControl';
import EllipsesMoment from '../../Common/EllipsesControl/EllipseMoment';
import ReactSelect from '../../Common/SelectDropdown/SelectDropdown';
import {useUserPreferences} from '../../../util/customHooks';

function RightSideSnapshotSelect(props) {
	const {user, defaultselectedSnapShot} = props;
	const [snapShotList, setSnapShotList] = useState([]),
		[selectedSnapShot, setSelectedSnapShot] = useState(defaultselectedSnapShot),
		[isDisabled, setisDisabled] = useState(false),
		[targetSnapShotList, setTargetSnapShotList] = useState([]);

	const userPreferences = useUserPreferences();
	const snapshots = useSelector((store) => store.snapshots),
		rightSideSnapshotId = useSelector((store) => store.clearRightSideSnapshotView);

	const formatSnapshots = (snapshots) => {
		let snapshotForDropDown = [];
		let snapShotsFromServer = [];
		setisDisabled(false);

		snapshotForDropDown.push({value: -1, label: labels.compareVersion, title: labels.compareVersion});
		if (snapshots && snapshots.length > 0) {
			snapShotsFromServer = snapshots.map((item) => {
				let snapshotName;

				switch (item.documentSourceID) {
					case documentSources.RESTORE:
						snapshotName = labels.snapshotRestore;
						break;
					case documentSources.ROLLFORWARD:
						snapshotName = labels.snapshotRollforward;
						break;
					case documentSources.COPYENGAGEMENT:
					case documentSources.COPYCANVASFORM:
						snapshotName = labels.snapshotCopy;
						break;
					default:
						snapshotName = item.userName;
				}

				return {
					value: item.id,
					label: item.userName,
					title: item.userName,
					userName: snapshotName,
					createDate: item.createDate
				};
			}, this);
		} else {
			setisDisabled(true);
			snapshotForDropDown = [];
			snapshotForDropDown.push({
				value: -1,
				label: labels.snapshotVersionNotAvailable,
				title: labels.snapshotVersionNotAvailable
			});
		}

		if (selectedSnapShot && selectedSnapShot.value !== -1) {
			setSelectedSnapShot(selectedSnapShot);
		} else {
			setSelectedSnapShot(snapshotForDropDown[0]);
		}

		setSnapShotList(snapShotsFromServer);
		setTargetSnapShotList(snapShotsFromServer);
	};

	const onTargetSnapshotChange = (option) => {
		const currentSnapshot = snapShotList.find((fl) => fl.value === option.value);
		setSelectedSnapShot(currentSnapshot);
		props.onTargetSnapshotChange(option);
	};

	const snapshotOptionLabel = ({label, userName, createDate}) => {
		return (
			<section className="selectText">
				{userName ? (
					<>
						<EllipseControl
							id="snapshotOptionNameLabel"
							content={userName}
							tooltip={userName}
							displayId={''}
							noOfLines={1}
						/>{' '}
						<EllipsesMoment
							id="snapshotOptionDateLabel"
							useFormat
							userPreferences={userPreferences}
							date={createDate}
							useLocal={false}
						/>
					</>
				) : (
					<EllipseControl id="snapshotOptionLabel" content={label} tooltip={label} displayId={''} noOfLines={1} />
				)}
			</section>
		);
	};

	useEffect(() => {
		if (rightSideSnapshotId !== 0) {
			const currentSnapshot = {value: -1, label: labels.compareVersion, title: labels.compareVersion};
			setSelectedSnapShot(currentSnapshot);
		}
	}, [rightSideSnapshotId]);

	useEffect(() => {
		formatSnapshots(snapshots);
	}, [snapshots]);

	return (
		<ReactSelect
			className="CanvasFormChangesSelect"
			formLabel={labels.version}
			groupHeading
			id="Snapshots"
			isSearchable
			formatOptionLabel={snapshotOptionLabel}
			defaultValue={selectedSnapShot}
			options={targetSnapShotList}
			onChange={onTargetSnapshotChange}
			value={selectedSnapShot}
			noOptionsMessage={() => labels.noResultsFound}
			isDisabled={isDisabled}
			theme={Utility.getTheme()}
		/>
	);
}

export default RightSideSnapshotSelect;
